import React from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import FormCrearPedido from './FormCrearPedido';

import { notification, Modal } from 'antd/lib';

import getPedidos from '../../../graphql/querys/ventas/getPedidos.graphql';
import insertPedido from '../../../graphql/mutations/venta/insertPedido.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

@compose(
  graphql(insertPedido, {
    name: 'insertPedido',
    options: {
      refetchQueries: [{ query: getPedidos }],
    },
  }),
  graphql(getUsuario)
)
class CrearPedido extends React.Component {
  onSubmit = values => {
    values.fechaPedido = values.fechaPedido.toDate();

    this.props
      .insertPedido({
        variables: {
          objPedido: values,
        },
      })
      .then(res => {
        if (res.data.insertPedido._id) {
          notification.success({
            message: 'Pedido Registrado',
            description:
              'El pedido se registró correctamente en la base de datos',
          });
          this.props.history.push('/');
        }
      })
      .catch(err => {
        console.log('Existio un error a la hora de crear el pedido');
        console.log(err);

        Modal.error({
          title: 'Error en la creacion del pedido',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  render() {
    return (
      <div>
        <br />
        <FormCrearPedido opcionRender={1} onSubmit={this.onSubmit} />
      </div>
    );
  }
}

export default withApollo(CrearPedido);
